if (window.contactFormSettings) {
  const settings = window.contactFormSettings;

  if (settings.enableSalesforce) {
    function timestamp() {
      var response = document.getElementById("g-recaptcha-response");
      if (response == null || response.value.trim() == "") {
        var elems = JSON.parse(document.getElementsByName("captcha_settings")[0].value);
        elems["ts"] = JSON.stringify(new Date().getTime());
        document.getElementsByName("captcha_settings")[0].value = JSON.stringify(elems);
      }
    }

    setInterval(timestamp, 500);

    const onLoad = () => {
      var element = document.querySelector(".js-form-submit");
      element.onclick = (e) => {
        e.preventDefault();

        const topicSelector = document.querySelector(".js-caseType");
        if (topicSelector) {
          const subject = document.querySelector(".js-subject");
          subject.value = topicSelector.value;
        }
        const formValid = validateForm();
        checkFormInput();
        if (formValid) grecaptcha.execute();
        else grecaptcha.reset();
      };
    };

    onLoad();
  } else {
    jQuery(document).ready(function () {
      jQuery('.submit-button').on('click', function (e) {
        formValidate('contact');
      });
      formValidate('contact');
    });
  }
}

document.addEventListener('DOMContentLoaded', function() {
  (function prepopulateType() {
    const select = document.querySelector('.js-caseType');
    if (!select) return;

    const requested = new URLSearchParams(window.location.search).get('populate[type]');
    if (!requested) return;

    for (let i = 0; i < select.options.length; i++) {
      if (select.options[i].value === requested && select.options[i].value !== '') {
        select.selectedIndex = i;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        break;
      }
    }
  })();

  const elements = {
    firstName: document.getElementById("firstname"),
    lastName: document.getElementById("lastName"),
    suppliedName: document.getElementById("SuppliedName")
  };

  if (!elements.firstName || !elements.lastName || !elements.suppliedName) {
    return;
  }

  function mergeName() {
    const firstName = elements.firstName.value.trim();
    const lastName = elements.lastName.value.trim();

    if (elements.suppliedName.getAttribute('swap-names') === 'true') {
      elements.suppliedName.value = (lastName + " " + firstName).trim();
    } else {
      elements.suppliedName.value = (firstName + " " + lastName).trim();
    }
  }

  [elements.firstName, elements.lastName].forEach(input => {
    if (input) {
      input.addEventListener('input', mergeName);
    }
  });
});
